export default {
    // 上に追加していく
    infos: [
        {
            "date": "20260309",
            "title": "言語処理学会第32回年次大会（NLP2026）に参加しました",
            "subtitle": "宇都宮で開催",
            "link": "/archive/20260309"
        },
        {
            "date": "20260308",
            "title": "第88回情報処理学会全国大会に参加しました",
            "subtitle": "松山で開催",
            "link": "/archive/20260308"
        },
        {
            "date": "20251212",
            "title": "国際会議NLPIR2025に参加しました",
            "subtitle": "福岡で開催",
            "link": "/archive/20251212"
        },
        {
            "date": "20251126",
            "title": "IDRユーザフォーラム2025で発表しました",
            "subtitle": "東京で開催",
            "link": "/archive/20251126"
        },
        {
            "date": "20251009",
            "title": "ビジネスチャレンジメッセTOKUSHIMA2025に出展しました",
            "subtitle": "徳島（アスティとくしま）で開催",
            "link": "/archive/20251009"
        },
        {
            "date": "20250927",
            "title": "令和7年度 電気・電子・情報関係学会四国支部連合大会に参加しました",
            "subtitle": "高知で開催",
            "link": "/archive/20250927"
        },
        {
            "date": "20250924",
            "title": "研究室説明会を開催しました",
            "subtitle": "TMAKLabの研究説明会を実施",
            "link": "/archive/20250924"
        },
        {
            "date": "20250918",
            "title": "第20回言語処理若手シンポジウム（YANS2025）に参加しました",
            "subtitle": "静岡で開催",
            "link": "/archive/20250918"
        },
        {
            "date": "20250917",
            "title": "第27回日本感性工学会大会に参加しました",
            "subtitle": "東京都江戸川区で開催",
            "link": "/archive/20250917"
        },
        {
            "date": "20250903",
            "title": "第24回情報科学技術フォーラム（FIT2025）に参加しました",
            "subtitle": "北海道で開催",
            "link": "/archive/20250903"
        },
        {
            "date": "20250821",
            "title": "大学見本市に参加しました",
            "subtitle": "東京で開催",
            "link": "/archive/20250821"
        },
        {
            "date": "20250818",
            "title": "データセットを公開しました",
            "subtitle": "データセットを公開",
            "link": "/archive/20250818"
        },
        {
            "date": "20250527",
            "title": "2025年度人工知能学会全国大会（JSAI2025）に参加しました",
            "subtitle": "大阪で開催",
            "link": "/archive/20250527"
        },
        {
            "date": "20250310",
            "title": "言語処理学会第31回年次大会（NLP2025）に参加しました",
            "subtitle": "長崎で開催",
            "link": "/archive/20250310"
        },
        {
            "date": "20250228",
            "title": "近畿大学東大阪キャンパスで開催されたHAIシンポジウム2025でポスター発表しました",
            "subtitle": "大阪で開催",
            "link": "/archive/20250228"
        },
        
          
        {
            "date": "20241215",
            "title": "8th-NLPIR 2024に参加しました",
            "subtitle": "岡山で開催",
            "link": "/archive/20241215"
        },
        {
            "date": "20241209",
            "title": "PACLIC38(2024)に参加しました",
            "subtitle": "東京外国語大学で開催",
            "link": "/archive/20241209"
        },
        {
            "date": "20241119",
            "title": "KEOD 2024に参加しました",
            "subtitle": "Portugal-Portoで開催",
            "link": "/archive/20241119"
        },
        {
            "date": "20240926",
            "title": "研究室説明会を実施します",
            "subtitle": "2024/9/26（木）、2024/9/27（金）でTMAKLabの研究室説明会を実施",
            "link": "/archive/20240926"
        },
        {
            "date": "20240914",
            "title": "第26回日本感性工学会大会に参加しました",
            "subtitle": "タワーホール船堀（東京都江戸川区）で開催",
            "link": "/archive/20240914"
        },
        {
            "date": "20240904",
            "title": "FIT2024に参加しました",
            "subtitle": "広島県の広島工業大学五日市キャンパスで発表",
            "link": "/archive/20240904"
        },
        {
            "date": "20240901",
            "title": "第17回ITヘルスケア学会に参加しました",
            "subtitle": "沖縄県の名桜大学で発表",
            "link": "/archive/20240901"
        },
        {
            "date": "20240531",
            "title": "JSAI2024に参加しました",
            "subtitle": "アクトシティ浜松(静岡県浜松市)で発表",
            "link": "/archive/20240531"
        },
        {
            "date": "20231003",
            "title": "留学生の歓迎を兼ねた懇親会を行いました",
            "subtitle": "A2研究室の先生方3人と、学生15人が参加しました。",
            "link": "/archive/20231003"
        },
        {
            "date": "20230924",
            "title": "研究室ホームページの更新を行いました。",
            "subtitle": "カルーセル内容充実、学生の声・Q&Aページの追加、Newの詳細ページ作成",
            "link": "/archive/20230924"
        },
        {
            "date": "20230519",
            "title": "研究室ホームページの更新を行いました。",
            "subtitle": "ホームのレイアウト変更，研究キーワード・研究内容の追加，設備ページ追加",
            "link": "/archive/20230519"
        },
        {
            "date": "20230331",
            "title": "研究室ホームページの更新を行いました。",
            "subtitle": "新メンバーの追加，JKAによる助成研究の業績追加，ホームのレイアウト変更",
            "link": "/archive/20230331"
        }

    ]
}

/* コピー用
{
    "date": "2023/4/1",
    "title": "あああ",
    "subtitle": "いいい",
},
*/

/* 過去のニュースはここに残していきましょう

*/